import styled from '@emotion/styled';

export const CardSubtitle = styled.p`
    font: ${(props) => props.theme.fonts.captionMedium};
    color: ${(props) => props.theme.palette.text.secondary};
`;
